import {Component, Optional, Inject} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';

export class DisbursementSummaryContext {
    constructor(public financeDisbursementRequestId) {}
}

@Component({
    selector: 'disbursement-summary-modal',
    templateUrl: './disbursement-summary-modal.html',
})
export class DisbursementSummaryModal {
    public title = 'View Disbursement Request';

    /**
     * Constructs the modal dialog
     * @param public dialog The dialog reference and dialog data
     */
    constructor(
        public dialogRef: MatDialogRef<DisbursementSummaryModal>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: DisbursementSummaryContext) {
        this.initPageData();
    }

    /**
     * Initializes page data
     */
    private initPageData() {
    }

    public cancel(): void {
        this.dialogRef.close();
    }
}
